import { vibrate } from "../utils/platform";
import "../styles/main.scss";

interface InstallBannerProps {
  canPromptInstall: boolean;
  onPromptInstall: () => void;
  onShowInstallHelp: () => void;
  onDismiss: () => void;
}

export function InstallBanner({
  canPromptInstall,
  onPromptInstall,
  onShowInstallHelp,
  onDismiss
}: InstallBannerProps) {
  const handleInstall = () => {
    vibrate(8);
    if (canPromptInstall) {
      onPromptInstall();
    } else {
      onShowInstallHelp();
    }
  };

  return (
    <div className="install-banner" role="status" aria-live="polite">
      <div className="install-banner__copy">
        <p className="install-banner__label">Install BlinkBli</p>
        <p className="install-banner__text">
          Get instant access by adding the app to your Home Screen.
        </p>
      </div>
      <div className="install-banner__actions">
        <button 
          type="button" 
          className="install-banner__link" 
          onClick={handleInstall}
        >
          Install as single page app
        </button>
        <button 
          type="button" 
          className="install-banner__dismiss" 
          onClick={() => { vibrate(4); onDismiss(); }}
          aria-label="Hide install banner"
        >
          Hide
        </button>
      </div>
    </div>
  );
}

